import { useCallback, useMemo } from "react";
import { MultiValue, PropsValue, SingleValue } from "react-select";
import { Unit } from "../types";

export function useCronFieldProps(
  value: PropsValue<number> | undefined,
  onChange: ((newValue: number[]) => void) | undefined,
  isMulti: boolean,
  unit: Unit,
) {
  const options: number[] = useMemo(() => {
    return [ ...new Array(unit.total) ].map((_, i) => unit.min === 0 ? i : i + 1);
  }, [ unit ]);

  const wrappedIsMulti = (Array.isArray(value) && value.length > 1) || isMulti;

  const wrappedOnChange = useCallback((selectValue: SingleValue<number> | MultiValue<number>) => {
    const newValue = Array.isArray(selectValue)
      ? selectValue
      : ((selectValue === null || selectValue === undefined) ? [] : [ selectValue ]);

    if (newValue.length === unit.total) {
      onChange?.([]);
    } else {
      newValue.sort();
      onChange?.(newValue);
    }
  }, [ onChange, unit.total ]);

  return {
    options,
    isMulti: wrappedIsMulti,
    onChange: wrappedOnChange,
  };
}